// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"324201e5","453":"5c99f4cf"}[chunkId] + ".chunk.js";
};